import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Router from 'next/router';
import userApi from 'api/userApi';
import { useUser } from '../../../hooks';
import { setHeaderTextSearch } from 'store/search';

const HeaderLogo = (props) => {
  const { selectedCentre } = props;
  const metaData = useSelector((state) => state.settingAccount.metaData);
  const dispatch = useDispatch();
  const user = useUser();
  const logoClick = async () => {
    if (user?._id) {
      const formData = new FormData();
      let dataForm = {
        firstName: user?.firstName,
        lastName: user?.lastName,
        bio: user?.bio ? user?.bio : '',
        language: user.language,
        twoFA: user.twoFA,
        mobile: user?.mobile,
        Mobilephoneno: user?.mobile?.slice(3, 13),
        mainPage: user?.mainPage ? user?.mainPage : null,
        monitoringUrl: `/lms-user/home`,
        dirtyFields: ['monitoringUrl'],
        // timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
      formData.append('data', JSON.stringify(dataForm));
      await userApi.updateUserById(user?._id, formData);
      if (metaData?.cmsHomePage) {
        await Router.push('/lms-user/home');
      } else {
        await Router.push('/homeCms');
      }
    } else {
      if (metaData?.cmsHomePage) {
        await Router.push('/lms-user/home');
      } else {
        await Router.push('/homeCms');
      }
    }
    dispatch(setHeaderTextSearch(''));
  };
  return (
    <>
      <div>
        {selectedCentre?.thumbnail ||
        (metaData?.logo && metaData?.logo[320]) ||
        metaData?.logo?.root ? (
          <div onClick={logoClick}>
            <img
              src={
                selectedCentre?.thumbnail
                  ? process.env.NEXT_PUBLIC_DOMAIN_IMG_HOST +
                    selectedCentre?.thumbnail
                  : (metaData?.logo && metaData?.logo[320]) ||
                    metaData?.logo?.root
              }
              className="header__logo mt-0"
              alt="logo"
              onClick={logoClick}
            />
          </div>
        ) : (
          <div className="header__logo mt-0" />
        )}
      </div>
    </>
  );
};

export default HeaderLogo;
